import { assignTabDataAndDispatch } from '../../actions';
import * as types from './constants';

export function addHistory(url, tabData, tabIndex) {
  const data = { url, tabData };
  return assignTabDataAndDispatch({ type: types.ADD_HISTORY, data }, tabIndex);
}
